import { uiTokens } from '@/theme/uiTokens';
import {
  CallSplit,
  Code,
  DocsIcon,
  Functions,
  Reorder,
  TrendingDownIcon,
} from '@/ui/primitives/icons';
import type { MetricCardItem } from '@/features/metrics/components/statusMetricCards';
import type { SvgIconComponent } from '@/ui/primitives';

export const resolveCoverageMetricCardIcon = (statusId: string): SvgIconComponent => {
  switch (statusId) {
    case 'lines':
      return Reorder;
    case 'functions':
      return Functions;
    case 'branches':
      return CallSplit;
    case 'statements':
      return Code;
    case 'files':
      return DocsIcon;
    case 'lowest-lines':
      return TrendingDownIcon;
    case 'total-lines':
      return Code;
    default:
      return Reorder;
  }
};

export const resolveCoverageMetricCardIconColor = (
  statusTone: MetricCardItem['statusTone'],
): string => {
  switch (statusTone) {
    case 'primary':
      return uiTokens.statusColors.teal;
    case 'info':
      return uiTokens.statusColors.blue;
    case 'warning':
      return uiTokens.statusColors.orange;
    case 'success':
      return uiTokens.statusColors.green;
    case 'error':
      return uiTokens.statusColors.red;
    case 'brown':
      return uiTokens.statusColors.brown;
    case 'default':
      return uiTokens.statusColors.neutral;
  }
};
